import { render, staticRenderFns } from "./suUdiListRecord.vue?vue&type=template&id=2c252d3b&scoped=true"
import script from "./suUdiListRecord.vue?vue&type=script&lang=js"
export * from "./suUdiListRecord.vue?vue&type=script&lang=js"
import style0 from "./suUdiListRecord.vue?vue&type=style&index=0&id=2c252d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c252d3b",
  null
  
)

export default component.exports